import { createContext } from 'react';
import { DEFAULT_LOCALE } from '../constants/localisation';

export const initialContextValue = {
  lps: {
    authorizedEntities: {},
    authorizedLps: null,
    lpSelected: null,
    authorizedDSPs: null,
  },
  localization: { locale: DEFAULT_LOCALE },
};
const CarrierLogisticsCommonsContext = createContext<any>(initialContextValue);

export default CarrierLogisticsCommonsContext;
